module.exports = __webpack_public_path__ + "static/media/tabNextArrow.9e7e1eb2.svg";